// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3yTBt","footer":"ModalUpdate_footer__1DO_w"};